export default () => {

  // ////////////////////////////////////////////////////
  // Jump Links markup example:
  //
  // <a href="#id-of-element" class="jump-link">Link</a>
  // ...
  // ...
  // <div id="id-of-element">Target Element</div>
  //
  // /////////////////////////////////////////////////////

  // scroll to element
  const scrollToEl = (el, id) => {
    el.scrollIntoView({ behavior: 'smooth' });
    history.pushState(null, null, id);
  };

  const jumpLink = document.querySelectorAll('.jump-link');

  if (jumpLink.length) {

    // each jump link on page
    jumpLink.forEach(function(el) {

      el.addEventListener('click', function(e) {

        e.preventDefault();

        // get hash value that corresponds to ID of element
        const id = this.getAttribute('href');

        // select element (value of jump-link)
        const targetEl = document.querySelector(id);

        // if the element exists...
        if (typeof (targetEl) !== 'undefined' && targetEl !== null) {

          // check to see if element is inside an accordion
          const isAccordion = targetEl.closest('.accordion-item');

          // if inside an accordion...
          if (isAccordion !== null) {

            // need to find the accordion button and see if it is already open
            const accordionButton = isAccordion.querySelector('.accordion-trigger');
            const isAccordionOpen = accordionButton.getAttribute('aria-expanded');

            // if accordion item that jump link is in, is not open...
            if (isAccordionOpen === 'false') {

              // open it
              accordionButton.click();

              // set a delay so that there is time to figure out scroll position after accordion opens
              setTimeout(() => {
                scrollToEl(targetEl, id);
              }, 250);

            // otherwise if accordion item was already open
            } else {
              scrollToEl(targetEl, id);
            }

          // if element is not inside an accordion
          } else {
            scrollToEl(targetEl, id);
          }

        }

      });

    });

  }

};
